<div>
<!--  <form #f="ngForm" (ngSubmit)="onSendMail(f)">-->
  <form #f="ngForm" (ngSubmit)="onRemoveCase(f.value)">

    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">Remove Case</mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="100" fxLayout="row" fxLayoutGap="8px">
          <div fxLayout="column" fxFlex="100">
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Epds Ctrl# (A#)</mat-label>
              <input matInput name="a_Num" ngModel required type="text">
            </mat-form-field>
            <mat-form-field floatLabel="always" appearance="outline">
              <mat-label>Reason to remove the case</mat-label>
              <textarea matInput name="reasonForDeletion" ngModel required type="text" class="message_layout" maxlength="255"></textarea>
            </mat-form-field>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center">
        <button mat-raised-button type="submit" color="warn" [disabled]="!f.valid || saving" class="spinner-black">
          <div *appSpinner="saving"></div>
          Remove
        </button>
<!--        <button mat-raised-button type="button" color="warn" (click)="onRemoveCase()" [disabled]="!f.valid || !f.dirty || saving">Remove</button>-->

      </mat-card-actions>
    </mat-card>
  </form>
</div>
